import client from '@/utils/httpClient';
import { useInfiniteQuery } from 'react-query';
import { ConferenceUserAssignemtKeys } from './conferenceUserAssignment.keys';

export interface ConferenceUserAssignment {
  id: string;
  hostOrganization: string;
  conferenceName: string;
  addedOn: Date;
}

function getAllConferenceUserAssignments(userId: string) {
  return client
    .get<ConferenceUserAssignment[]>(`/conferenceuserassignments/list/${userId}`)
    .then((response) => {
      const data = response.data as ConferenceUserAssignment[];

      return data;
    });
}

export function useGetAllConferenceUserAssignments(userId: string) {
  return useInfiniteQuery(ConferenceUserAssignemtKeys.list(), () =>
    getAllConferenceUserAssignments(userId),
  );
}
